import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Header } from "./components/header"
import { Footer } from './components/footer'
import Home from './pages/Home'
import AboutTest from './pages/AboutTest'
import History from './pages/about/History'
import Awards from './pages/about/Awards'
import Facilities from './pages/about/Facilities'
import Infrastructure from './pages/about/Infrastructure'
import PranaamGlance from './pages/about/PranaamGlance'
import InTheNews from './pages/about/InTheNews'
import Contact from './pages/Contact'
import MaternityMatters from './pages/MaternityMatters'
import Locations from './pages/Locations'
import MadinagudaBranch from './pages/locations/MadinagudaBranch'
import NallagandlaBranch from './pages/locations/NallagandlaBranch'
import IsnapurBranch from './pages/locations/IsnapurBranch'
import ZaheerabadBranch from './pages/locations/ZaheerabadBranch'
import Services from './pages/Services'
import Cardiology from './pages/services/Cardiology'
import Neurology from './pages/services/Neurology'
import Orthopedics from './pages/services/Orthopedics'
import Paediatric from './pages/services/Paediatric'
import PaediatricSurgery from './pages/services/PaediatricSurgery'
import Gynaecology from './pages/services/Gynaecology'
import Dentistry from './pages/services/Dentistry'
import Gastroenterology from './pages/services/Gastroenterology'
import GeneralSurgery from './pages/services/GeneralSurgery'
import GeneralMedicine from './pages/services/GeneralMedicine'
import Neonatology from './pages/services/Neonatology'
import PrenatalYoga from './pages/services/PrenatalYoga'
import CriticalCare from './pages/services/CriticalCare'
import Pathology from './pages/services/Pathology'
import Neurosurgery from './pages/services/Neurosurgery'
import Oncology from './pages/services/Oncology'
import UrologyNephrology from './pages/services/UrologyNephrology'
import LaparoscopicSurgery from './pages/services/LaparoscopicSurgery'
import Physiotherapy from './pages/services/Physiotherapy'
import Dietetics from './pages/services/Dietetics'
import Dermatology from './pages/services/Dermatology'
import ENT from './pages/services/ENT'
import Endocrinology from './pages/services/Endocrinology'
import Pulmonology from './pages/services/Pulmonology'
import PlasticCosmeticSurgery from './pages/services/PlasticCosmeticSurgery'
import Psychology from './pages/services/Psychology'
import Radiology from './pages/services/Radiology'
import DiagnosticsPage from './pages/DiagnosticsPage'
import Videos from './pages/media/Videos'
import Blogs from './pages/media/Blogs'
import DoctorsPage from './pages/DoctorsPage'
import BookAppointment from './pages/BookAppointment'
import ScrollToTop from './pages/ScrollToTop'
import Doctordetail from './pages/Doctordetail'
import BlogDetailPage from './pages/blogs/BlogDetail'
import Testimonials from './pages/testimonials'
import Servicesdetail from './pages/services/Servicesdetail'
import Notfound from './pages/404'



import "./index.css"
function App() {


  return (
    <BrowserRouter>
      <Header />
       <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutTest />} />
        <Route path="/about/History" element={<History />} />
        <Route path="/about/Awards" element={<Awards />} />
        <Route path="/about/Facilities" element={<Facilities />} />
        <Route path="/about/Infrastructure" element={<Infrastructure />} />
        <Route path="/about/PranaamGlance" element={<PranaamGlance />} />
        <Route path="/about/InTheNews" element={<InTheNews />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/maternity-matters" element={<MaternityMatters />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/madinaguda" element={<MadinagudaBranch />} />
        <Route path="/locations/nallagandla" element={<NallagandlaBranch />} />
        <Route path="/locations/isnapur" element={<IsnapurBranch />} />
        <Route path="/locations/zaheerabad" element={<ZaheerabadBranch />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<Servicesdetail />} />
        <Route path="/diagnostics" element={<DiagnosticsPage />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/doctors" element={<DoctorsPage />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
        <Route path="/doctors/:slug" element={<Doctordetail />} />
        <Route path="/blogs/:slug" element={<BlogDetailPage />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="*" element={<Notfound />} />
        </Routes>
        <Footer />
        </BrowserRouter>
  )
}

export default App